import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const FinishOauthSignupModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "FinishOauthSignupModalContainer" */
      './FinishOauthSignupModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
